(function () {
    'use strict';

    /**
     * Have to configure a template for the Wix angular-tree-control this way because it isn't using $templateRequest.
     * https://github.com/wix/angular-tree-control/pull/251
     */

    angular.module('treeControl').run(function ($templateCache) {
        var template =
            '<ul {{options.ulClass}} >' +
            '<li ng-repeat="node in node.{{options.nodeChildren}} | filter:filterExpression:filterComparator {{options.orderBy}}" ng-class="headClass(node)" {{options.liClass}} set-node-to-data>' +

            '<span style="width: 24px; display: inline-block;">' +
            '<drv-icon usage="\'chevron right\'" ng-click="selectNodeHead(node)" ng-show="!nodeExpanded() && node.children"></drv-icon>' +
            '<drv-icon usage="\'chevron down\'" ng-click="selectNodeHead(node)" ng-show="nodeExpanded() && node.children"></drv-icon>' +
            '</span>' +

            '<div class="tree-label {{options.labelClass}}" ng-class="[selectedClass(), unselectableClass()]" ng-click="selectNodeLabel(node)">' +
            '<input type="checkbox" ng-checked="isSelectedNode(node)" ng-if="options.multiSelection" ng-disabled="!options.isSelectable(node)"></input>' +
            '<i class="tree-leaf-head {{options.iLeafClass}}"></i>' +
            '<i class="tree-branch-head" ng-class="options.injectClasses.iCollapsed"></i>' +
            '<tree-transclude></tree-transclude>' +
            '</div>' +

            '<treeitem ng-if="nodeExpanded()"></treeitem>' +
            '</li>' +
            '</ul>';

        $templateCache.put('angular-tree-control.tmpl.html', template);
    });
})();